<ds-tag
  [icon]="params?.value ? 'checkbox_circle' : 'close_circle'"
  [tone]="params?.value ? 'positive' : 'critical'"
  >{{
    (params?.value ? 'common.words.yes' : 'common.words.no') | translate
  }}</ds-tag
>
